export const CommonVerificationCodeDialog = {
  width: '640px',
  data: {
    title: 'app.dialog.info.logout-title',
    content: 'app.dialog.info.logout',
    cancelButtonLabel: 'app.labels.completed',
  },
  disableClose: true,
};

export const MaturityRequestVerificationCodeDialog = {
  width: '640px',
  data: {
    title: 'app.identification.maturity.dialog.title',
    contentTitle: 'app.identification.maturity.dialog.contentTitle',
    content: 'app.identification.maturity.dialog.description',
    cancelButtonLabel: 'app.labels.completed',
    dataCy: 'identification.maturity.dialog.completed',
  },
  disableClose: true,
};
